var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSocialYoutube(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.7636 7.86425C21.4407 6.08226 20.3182 5.56442 18.6884 5.33596C17.5352 5.16843 14.1987 4.98566 11.9846 5.00089C9.77053 5.00089 6.44938 5.16843 5.2962 5.33596C3.66638 5.56442 2.54396 6.08226 2.22107 7.86425C1.89818 9.64623 1.97506 14.7637 2.15957 15.8603C2.34407 16.9569 2.75922 18.2211 4.74268 18.6932C5.84973 18.9521 9.07862 19.0131 12 18.9978C14.9214 18.9978 18.1503 18.9521 19.2573 18.6932C21.2408 18.2211 21.6559 16.9569 21.8404 15.8603C22.0249 14.7637 22.1018 9.66146 21.7789 7.86425H21.7636ZM9.83203 14.2459V9.76807C9.83203 9.40254 10.2318 9.17408 10.5547 9.35685L14.6292 11.5957C14.9675 11.7785 14.9675 12.2507 14.6292 12.4334L10.5547 14.6723C10.2318 14.8551 9.83203 14.6114 9.83203 14.2611V14.2459Z",
    fill: "#0C0C0C"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSocialYoutube);
export default __webpack_public_path__ + "static/media/social_youtube.5d43cfbcc44ba4e9ab213e295bea129b.svg";
export { ForwardRef as ReactComponent };